import { render, staticRenderFns } from "./companyCreateModal.vue?vue&type=template&id=3de4402a&"
import script from "./companyCreateModal.vue?vue&type=script&lang=ts&"
export * from "./companyCreateModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports